/* =====================================================================
   HERTAPE ISSUE — Lazy Fade-In Observer
   Adds smooth fade-in animation when images scroll into view.
   ===================================================================== */

(function () {
  'use strict';

  function initLazyFade() {
    var images = document.querySelectorAll('.hertape-issue .lazy-fade');
    if (images.length === 0) return;

    // Fallback for browsers without IntersectionObserver
    if (!('IntersectionObserver' in window)) {
      images.forEach(function (img) {
        img.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // If image is already loaded, fade in immediately
            if (entry.target.complete) {
              entry.target.classList.add('is-visible');
            } else {
              entry.target.addEventListener('load', function () {
                entry.target.classList.add('is-visible');
              });
              // Safety net — also fire after 600ms in case load event missed
              setTimeout(function () {
                entry.target.classList.add('is-visible');
              }, 600);
            }
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    images.forEach(function (img) {
      observer.observe(img);
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyFade);
  } else {
    initLazyFade();
  }

  // Re-init when Shopify Theme Customizer adds/changes sections
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initLazyFade);
  }
})();
